import router from './router';
import intro from './components/intro';
import introMobile from './components/intro-mobile';
import announcements from './components/announcements';
// import helpers from './helpers';
import animationSlide from './animationSlide';

const $header = $('header');

const toogleTheme = (isBolean) => {
	if (isBolean) {
		$header.addClass('white');
	} else {
		$header.removeClass('white');
	}
};

const $container = $('.site');
const arraySlide = [];
let i = 1;

const iteration = 8; // сюда писать количество data-slide
while (i < iteration) {
	arraySlide.push(i);
	i++;
}

gsap.from($container, {
	onComplete() {
		$container.removeClass('is-opacity');
		$header.removeClass('is-opacity');
	},

	duration: 0.5,
	opacity: 0,
	clearProps: 'all',
});

function enter(page, num) {
	return new Promise((resolve) => {
		let pageName = page;
		let $page = $(`body [data-page="${pageName}"]`);
		const slides = arraySlide.some((item) => item === +page);

		if (typeof num !== 'undefined') {
			$page = $(`[data-page="${pageName}-${num}"]`);
		}

		if (slides) {
			animationSlide.enter(pageName, num);
			pageName = 'home';
			$page = $(`body [data-page="${pageName}"]`);
		}

		const theme = $page.data('theme');
		if (theme === 'white') {
			toogleTheme(true);
		} else {
			toogleTheme(false);
		}

		// eslint-disable-next-line no-unused-expressions
		pageName !== 'home' ? $('.header__back').addClass('active') : $('.header__back').removeClass('active');

		if (!$page.length) {
			router.navigate('/');

			resolve();

			// eslint-disable-next-line consistent-return
			return;
		}
		gsap
			.from($container, {
				onStart() {
					$page.removeClass('is-hidden');
					$container.removeClass('is-hidden');
					if (pageName === 'home') {
						intro.init();
						introMobile.init();
					}
					if (pageName === 'article') {
						announcements.init(num, pageName);
					}

					console.log($page)
					if (pageName === 'podcasts') {
						$('.footer').addClass('is-hidden');
					} else {
						$('.footer').removeClass('is-hidden');
					}
				},
				onComplete() {
					resolve();
				},
				duration: 0.3,
				opacity: 0,
				clearProps: 'all',
			}, 0);
	});
}

function leave(page, num) {
	return new Promise((resolve) => {
		let $page = $(`body [data-page="${page}"]`);
		const slides = arraySlide.some((item) => item === +page);

		if (slides) {
			animationSlide.reset();
			$page = $('body [data-page="home"]');
		}
		if (typeof num !== 'undefined') {
			$page = $(`[data-page="${page}-${num}"]`);
		}
		if ($page === 'home') {
			intro.destroy();
			introMobile.destroy();
		}

		if ($page === 'article') {
			announcements.destroy();
		}

		gsap.to($container, {
			onComplete() {
				$container.addClass('is-hidden');
				$page.addClass('is-hidden');

				resolve();
			},

			duration: 0.3,
			opacity: 0,
			clearProps: 'all',
		});
	});
}

export default {
	enter,
	leave,
};
